import { useEffect, useState, createRef } from "react";
import { disableMapEvents, updateUrl, addLayerToMap } from "../utils/mapFunctions";
import { getDatasetsJson } from "../utils/DatasetsJson";

const DatasetsControl = (props) => {
  const map = props.map;
  const DatasetsJson = getDatasetsJson();
  const id = props.id;
  const layers = props.layers;
  const panelRef = createRef();
  const [data, seData] = useState({});
  const [openDatasets, setOpenDatasets] = useState({});

  useEffect(() => {
    disableMapEvents(panelRef);
  }, [panelRef]);

  useEffect(() => {
    let datasets = DatasetsJson.find(a => a.id === id).datasets;
    seData(datasets);
  }, [DatasetsJson, id]);

  const toggleDataset = (index) => {
    setOpenDatasets((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleAddLayer = async (url, id, title, layerName, layerData) => {
    const layer = await addLayerToMap(map, layers, url, id, layerName, layerData);
    if (layer) {
      props.addLayer(layer, url, id, title, layerName);
      updateUrl(id);
    } else {
      console.log("Error loading layer");
    }
  }

  return (
    <div className="widget-panel-overlay" ref={panelRef}>
      <div className="widget-title">
        Select layers
        <button className="icon-button widget-close" onClick={() => {props.setShowDatasets(null)}} aria-label="Close">
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="datasets-container">
        {
          data.length > 0 &&
          data.map((dataset, i) => (
            dataset.layers?.length > 0 &&
            <div className={"filter-item" + (openDatasets[i] ? " expanded" : "")} key={i}>
              <div className="filter-header">
                <div className="datasets-title">
                  {dataset.label}
                  <div className="detail-icon detail-layers">
                    <i className="fa-solid fa-layer-group"></i>
                    <span>{dataset.layers.length}</span>
                  </div>
                </div>
                <button className="icon-button" onClick={() => toggleDataset(i)} aria-label={openDatasets[i] ? "Hide dataset" : "Show dataset"}>
                  <i className="fa-solid fa-chevron-down"></i>
                </button>
              </div>
                
              <div className="filter-options">
                {
                  dataset.layers.map((layer, i) => (
                    <div className="datasets-layer" key={i}>
                      <div>
                        {layer.name_en}
                        {layer.unit && <span className="datasets-unit">({layer.unit})</span>}
                      </div>
                      <div className="catalogue-buttons">
                        <button
                          className="ccl-button ccl-button--default"
                          disabled={layers.some(a => a.id === layer.num_layer)}
                          onClick={() => handleAddLayer(layer.GetTile || dataset.GetMap, layer.num_layer, layer.name_en, layer.layer_name, {...layer, "url": layer.GetTile || dataset.GetMap, "type": dataset.map_service})}
                          aria-label="Add layer"
                        >
                          {layers.some(a => a.id === layer.num_layer) ? "Added" : "Add"}
                        </button>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default DatasetsControl;
